import {
	animation,
	calcMulti,
	DataAttributes,
	keyframes,
	respondToRange,
	StyledProductPicker,
} from "@animech/ui";
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { ZIndex } from "src/ui/constants";

export type ViewProps = DataAttributes<{
	"logo-desktop": boolean;
	"logo-mobile": boolean;
}>;

export const View = styled.div<ViewProps>``;
export const ProductPicker = styled.div``;

export const Root = styled.div`
	${({ theme }) => {
		const logoOffset = calcMulti(
			[theme.app.logo.height, theme.app.logo.marginVertical],
			([height, spacing]) => height + spacing * 2,
		);
		const mobileLogoOffset = calcMulti(
			[theme.app.logo.height, theme.app.logo.mobileMarginVertical],
			([height, spacing]) => height + spacing * 2,
		);

		return css`
			position: absolute;
			top: 0;
			left: 0;
			z-index: ${ZIndex.Overlay};
			height: 100%;
			width: 100%;
			background: ${theme.app.panels.overlayBackground};

			${View} {
				${animation([
					{
						keyframes: keyframes.slideInUp("200px"),
						duration: theme.app.panels.transitionDuration,
						timingFunction: theme.app.panels.transitionTimingFunction,
						fillMode: "forwards",
					},
					{
						keyframes: keyframes.fadeIn(),
						duration: theme.app.panels.transitionDuration,
						timingFunction: theme.app.panels.transitionTimingFunction,
						fillMode: "forwards",
					},
				])}
				display: flex;
				position: absolute;
				align-items: center;
				justify-content: center;
				height: 100%;
				width: 100%;

				&[data-logo-desktop] {
					margin-top: ${logoOffset};
					height: calc(100% - ${logoOffset});
				}
			}

			${ProductPicker} {
				display: flex;
				flex-direction: column;
				height: 100%;
				width: 100%;
				color: ${theme.colors.palette.white};
				text-align: center;

				/* Ensure product picker widget covers the rest of the page */
				> ${StyledProductPicker.ProductPicker} {
					flex: 1;
				}
			}

			${respondToRange(theme, "tablet", "down")} {
				${View} {
					animation: none;

					&[data-logo-desktop] {
						margin-top: 0;
						height: 100%;
					}

					&[data-logo-mobile] {
						margin-top: ${mobileLogoOffset};
						height: calc(100% - ${mobileLogoOffset});
					}
				}
			}
		`;
	}}
`;
